import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import { fetchEdgeLeaderboard } from "../lib/api";
import { Trophy, ArrowLeft, CaretUp, CaretDown, Sparkle } from "@phosphor-icons/react";
import { formatPct, formatSignedPct } from "../lib/format";

export default function EdgeLeaderboard() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchEdgeLeaderboard(30)
      .then((d) => setItems(d.items || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-background" data-testid="edge-page">
      <Header />
      <div className="mx-auto max-w-4xl px-6 py-10">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-xs font-mono uppercase tracking-widest text-zinc-400 hover:text-white mb-6"
        >
          <ArrowLeft size={14} /> Back
        </Link>

        <div className="flex items-center gap-3 mb-2">
          <Trophy size={22} weight="duotone" className="text-edge" />
          <h1 className="font-display text-3xl font-medium">AI Edge Leaderboard</h1>
        </div>
        <p className="text-sm text-zinc-400 font-body max-w-2xl mb-10">
          Markets where MFSMAI Oracle disagrees most with Polymarket. Ranked by absolute edge.
          These are the strongest mispricing candidates.
        </p>

        {loading ? (
          <div className="text-zinc-500 font-mono text-xs uppercase tracking-widest">Loading…</div>
        ) : items.length === 0 ? (
          <div className="border border-white/10 p-10 text-center text-zinc-500 font-body">
            <Sparkle size={28} weight="duotone" className="mx-auto mb-3 text-edge" />
            No forecasts yet. Run some AI predictions or wait for the background scan (every 2h).
          </div>
        ) : (
          <div className="border border-white/10 divide-y divide-white/5">
            {items.map((f, i) => {
              const edge = f.edge || 0;
              const dir = edge >= 0 ? "text-profit" : "text-loss";
              return (
                <Link
                  key={f.marketId}
                  to={`/market/${f.marketId}`}
                  data-testid={`edge-row-${f.marketId}`}
                  className="flex items-center gap-4 p-4 hover:bg-white/5 transition-colors"
                >
                  <div className="font-mono text-2xl tabular-nums text-zinc-500 w-9">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-display text-sm font-medium line-clamp-2">
                      {f.question}
                    </div>
                    <div className="mt-1 flex items-center gap-3 text-[11px] font-mono tabular-nums text-zinc-500">
                      <span>MKT {formatPct(f.marketYesPrice, 0)}</span>
                      <span className="text-edge">AI {formatPct(f.probability, 0)}</span>
                      <span>{f.verdict}</span>
                    </div>
                  </div>
                  <div className={`text-right font-mono tabular-nums ${dir}`}>
                    <div className="text-2xl font-medium inline-flex items-center gap-0.5">
                      {edge >= 0 ? <CaretUp size={14} weight="fill" /> : <CaretDown size={14} weight="fill" />}
                      {formatSignedPct(edge, 1)}
                    </div>
                    <div className="text-[10px] uppercase tracking-widest text-zinc-500">edge</div>
                  </div>
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
